<template>
  <baidu-map id="mapContainer" ref="mapContainer" class="map_ddensity" center="上海" :scroll-wheel-zoom="map.scrollWheelZoom"
    :dragging="map.dragging" :double-click-zoom="map.dbClickZoom" :mapStyle="map.mapStyle" @ready="ready">
    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT">
    </bm-navigation>
    <bm-control :offset="{width:5,height:5}">
      <el-tooltip effect="dark" content="设置网格大小" placement="bottom">
        <el-select v-model="grid.currentLevel" placeholder="请选择" @change="handleSizeChange" style="width:120px;">
          <el-option v-for="(size, sizeLevel) in grid.allSize" :key="size" :label="sizeLevel" :value="sizeLevel">
          </el-option>
        </el-select>
      </el-tooltip>
    </bm-control>
  </baidu-map>
</template>
<script>
  export default {
    components: {},
    watch: {},
    data() {
      return {
        // 地图容器参数
        map: {
          mapInterface: null, //BMap类
          mapInstance: null, //map实例
          scrollWheelZoom: true,
          dragging: true,
          dbClickZoom: false,
          mapStyle: {}
        },
        devices: [], //所有的设备
        grid: {
          allGrid: {},
          currentGrid: {}, //key->{value:Int,path:[]} path 依次为 左上角 右上角 右下角 左下角
          allSize: {
            "3 km": 0.02965769,
            "5 km": 0.049429483,
            "10 km": 0.098858965
          }, //网格级别 若此参数发生改变 则必须调用this.createAndSaveGrid重新生成网格文件
          currentLevel: "5 km",
          currentSize: 0.049429483, //密度网格大小 单位 度 1km约等于0.01   默认5km
          styleOptions: {
            strokeColor: "#f4f3ef", //网格边线颜色。
            strokeWeight: 1, //网格边线的宽度，以像素为单位。
            strokeOpacity: 0.3, //网格边线透明度，取值范围0 - 1。
            strokeStyle: "solid", //网格边线的样式，solid或dashed。
            fillOpacity: 0.5 //网格填充的透明度，取值范围0 - 1。
          }
        }
      };
    },
    created() {
      this.$getJSON("/admin/readFile", {
        path: "mapStyle/GIS.json",
        encoding: "utf8"
      }).then(res => this.map.mapStyle = JSON.parse(res.data));
    },
    mounted() {},
    methods: {
      async ready(params) {
        //获取百度地图的实例 待用
        this.map.mapInterface = params.BMap;
        this.map.mapInstance = params.map;

        // // 生成行政区内的网格并保存到文本（运行一次即可 且不要与后面的函数同时运行）
        // this.createAndSaveGrid(
        //   this.map.mapInterface,
        //   "上海市",
        //   "grid/shanghai.json",
        //   this.grid.allSize
        // );

        //从文件读取网格
        this.grid.allGrid = await this.getGridFromFile("grid/shanghai.json");

        //设置当前网格级别 默认 5 km
        this.grid.currentGrid = JSON.parse(
          JSON.stringify(this.grid.allGrid["5 km"])
        );

        //绘制上海市行政区边界
        this.drawBoundary("上海市");

        //计算并绘制网格密度
        this.searchAndDraw();
      },

      handleSizeChange() {
        this.grid.currentSize = this.grid.allSize[this.grid.currentLevel];
        this.grid.currentGrid = JSON.parse(
          JSON.stringify(this.grid.allGrid[this.grid.currentLevel])
        );
        this.setGridDensity();
        this.drawGrid();
      },

      //绘制行政区边界
      drawBoundary(district) {
        let BMap = this.map.mapInterface;
        let map = this.map.mapInstance;
        let bdary = new BMap.Boundary();
        bdary.get(district, rs => {
          //获取行政区域
          let count = rs.boundaries.length; //行政区域的polygon个数，对于有分离部分的行政区 可能有多个
          if (count === 0) {
            return;
          }
          let pointArray = [];
          let ply = new BMap.Polygon(rs.boundaries[0], {
            strokeWeight: 2,
            strokeColor: "#ff0000",
            fillOpacity: 0.1,
            enableMassClear: false
          }); //建立行政区边界多边形覆盖物 并赋予样式
          map.addOverlay(ply); //添加覆盖物
          pointArray = pointArray.concat(ply.getPath());
          map.setViewport(pointArray); //调整视野
        });
      },

      //创建网格并保存到文件
      //district 网格区域的行政区名字  这里为“上海市”
      //savePath 文件保存地址（服务器路径）
      //sizeList 网格尺寸，用以生成不同级别的网格
      createAndSaveGrid(BMap, district, savePath, sizes) {
        let grid = {};
        let bdary = new BMap.Boundary();
        bdary.get(district, rs => {
          let path = new BMap.Polygon(rs.boundaries[0]).getPath();
          for (let size in sizes) {
            grid[size] = {
              size: sizes[size],
              gridIdx: this.createGridByDistrictPath(path, sizes[size])
            };
          }
          this.$getJSON("/admin/saveFile", {
            path: savePath,
            data: JSON.stringify(grid),
            encoding: "utf8"
          });
        });
      },

      //根据行政区边界生成所有显示范围内的网格
      createGridByDistrictPath(path, size) {
        let gridIdx = [];
        let boundaryGrids = [];
        const cnt = path.length;
        //首先生成边界线上的网格
        for (let i = 0; i < cnt; i++) {
          let start = {};
          start.row = Math.ceil(path[i].lat / size);
          start.col = Math.ceil(path[i].lng / size);
          boundaryGrids.push([start.row, start.col]); //每条边的起点所在网格直接保存
          //计算每条边除了起点和终点外，中间是否还有经过的网格
          let next = (i + 1) % cnt;
          let end = {};
          end.row = Math.ceil(path[next].lat / size);
          end.col = Math.ceil(path[next].lng / size);
          let deltaRow = end.row - start.row;
          let deltaCol = end.col - start.col;
          let absDRow = Math.abs(deltaRow);
          let absDCol = Math.abs(deltaCol);
          if (absDRow <= 1 && absDCol <= 1) continue;
          let absMax = Math.max(absDRow, absDCol);
          let absMin = Math.min(absDRow, absDCol);
          let deltaListMax = []; //保存边经过的网格的下标增量
          let deltaListMin = [];
          for (let j = 1; j < absMax; j++) {
            //差值较大的一维 网格下标递增
            //差值较小的一维 网格下标按比例增加
            deltaListMax.push(j);
            deltaListMin.push(Math.floor(j / (absMax / absMin)));
          }
          let deltaList =
            absDRow >= absDCol ? [deltaListMax, deltaListMin] : [deltaListMin, deltaListMax];
          let intervalRow = deltaRow > 0 ? 1 : -1;
          let intervalCol = deltaCol > 0 ? 1 : -1;
          for (let j = 0; j < deltaList[0].length; j++) {
            boundaryGrids.push([
              start.row + deltaList[0][j] * intervalRow,
              start.col + deltaList[1][j] * intervalCol
            ]);
          }
        }
        //填充边线内部的网格
        //直接按行扫描  不考虑凹多边形的特殊情况
        let rows = boundaryGrids.map(item => item[0]);
        let rowMax = rows.max();
        let rowMin = rows.min();
        for (let row = rowMin; row <= rowMax; row++) {
          let cols = [];
          boundaryGrids.map(item => {
            if (item[0] == row) {
              cols.push(item[1]);
            }
          });
          let colMax = cols.max();
          let colMin = cols.min();
          gridIdx.push([row, colMin, colMax]);
        }
        return gridIdx;
      },

      //添加（如果不存在）网格到obj，并设置网格值
      addGrid(obj, row, col, value, size) {
        let key = `idx_${row}_${col}`; //用行列号作为key 从而生成一个映射表
        if (obj[key]) {
          obj[key].value += value;
        } else {
          obj[key] = {
            value: value,
            path: [{
                lng: (col - 1) * size,
                lat: row * size
              },
              {
                lng: col * size,
                lat: row * size
              },
              {
                lng: col * size,
                lat: (row - 1) * size
              },
              {
                lng: (col - 1) * size,
                lat: (row - 1) * size
              }
            ]
          };
        }
      },

      //从文件读取网格
      async getGridFromFile(path) {
        let allGrid = {};
        let res = await this.$getJSON("/admin/readFile", {
          path: path,
          encoding: "utf8"
        });
        let gridInfo = JSON.parse(res.data);
        for (let sizeLevel in this.grid.allSize) {
          let grid = {};
          let size = gridInfo[sizeLevel].size;
          let gridIdx = gridInfo[sizeLevel].gridIdx;
          for (let i = 0; i < gridIdx.length; i++) {
            const element = gridIdx[i];
            for (let col = element[1]; col <= element[2]; col++) {
              this.addGrid(grid, element[0], col, 0, size);
            }
          }
          allGrid[sizeLevel] = grid;
        }
        return allGrid;
      },

      //获取设备信息 以设置密度信息 并将最终密度网格添加到地图
      searchAndDraw() {
        this.$getJSON("/terminal/s_devicelst_all", {}).then(res => {
          this.devices = res.data;
          //创建并绘制格网
          this.setGridDensity();
          this.drawGrid();
        });
      },

      //设置每个网格的密度信息
      setGridDensity() {
        let size = this.grid.currentSize; //网格大小 单位 度
        for (let i = 0; i < this.devices.length; i++) {
          const device = this.devices[i];
          //获取设备所在网格的行列号
          let row = Math.ceil(device.lat / size);
          let col = Math.ceil(device.lon / size);
          this.addGrid(this.grid.currentGrid, row, col, 1, size);
        }
      },

      //将网格添加到地图  此处使用的是百度地图的实例  调用其API实现
      //未使用BmPolygon组件的原因是 其渲染有时会不成功 原因未知
      drawGrid() {
        let BMap = this.map.mapInterface;
        let map = this.map.mapInstance;
        map.clearOverlays();
        for (let key in this.grid.currentGrid) {
          let cell = this.grid.currentGrid[key];
          let polygonOptions = this.grid.styleOptions;
          polygonOptions.fillColor =
            "#" +
            Math.floor(
              ((cell.value * 9301 + 49297) % 233280) / 233280.0 * 0xffffff
            ).toString(16);
          let polygon = new BMap.Polygon(
            cell.path.map(pnt => new BMap.Point(pnt.lng, pnt.lat)),
            polygonOptions
          );
          map.addOverlay(polygon);
          if (cell.value == 0) continue; //密度为0时 不设置标签
          let labelOptions = {
            offset: new BMap.Size(-9, -10),
            position: new BMap.Point(
              (cell.path[0].lng + cell.path[1].lng) / 2,
              (cell.path[1].lat + cell.path[2].lat) / 2
            )
          };
          let label = new BMap.Label(`${cell.value}`, labelOptions); //标签 用于显示网格密度值
          label.setStyle({
            border: 0,
            backgroundColor: "rgba(0,0,0,0)",
            color: "white",
            fontSize: "12px",
            height: "20px",
            lineHeight: "20px",
            fontFamily: "微软雅黑",
            textAlign: "center",
            width: "18px",
            padding: "0"
          });
          map.addOverlay(label);
        }
      }
    }
  };

</script>
<style>
  .map_ddensity {
    width: 100%;
    height: 100%;
  }

  .map_ddensity .anchorBL {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/DeviceGridDensity.vue